import { request } from "../utils/request.js"

export const customerMedicalRecord_addNew = (pojo, args) => request({
    url: 'customerMedicalRecord/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})
export const customerMedicalRecord_update = (pojo, args) => request({
    url: 'customerMedicalRecord/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customerMedicalRecord_existsByCustomerId = (customerId, args) => request({
    url: 'customerMedicalRecord/existsByCustomerId',
    method: 'GET',
    params: { customerId },
    showFailMessage: true,
    ...args
})


export const customerMedicalRecord_findById = (id, args) => request({
    url: 'customerMedicalRecord/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/customerMedicalRecord.js